module.exports = __webpack_public_path__ + "img/header-weddingRingsBudgetLow.39cb2ab.webp";